export { default as Segment } from './Segment'
